<template>
  <div class="row">
    <div class="col-2 b-form__container_min-width_200">
      <div>
        <label>{{$t('CONTENT.payments.payment_first_date')}}:</label>
        <datepicker class="b-datepicker" v-model="newFirstPaymentDate" :formatter="datepickerFormat" :disabled="isLastPeriodDate"></datepicker>
        <checkbox class="b-checkbox" v-model="isLastPeriodDateCom">{{$t('CONTENT.payments.is_last_period_date')}}</checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import ChangeFirstPaymentDate from "../../models/commands/ChangeFirstPaymentDate";
import dateConverter from "@/utils/converters/date.converter";
import datepickerFormat from '@/mixins/datepickerFormat.mixin';

export default {
  components: {},
  props: {
    paymentParams: {
      type: Object,
      required: true
    }
  },
  mixins: [datepickerFormat],
  data() {
    return {
      newFirstPaymentDateAsString: null,
      isLastPeriodDate: false
    };
  },
  computed: {
    newFirstPaymentDate: {
      get() {
        if (this.newFirstPaymentDateAsString === null) {
          return null;
        } else {
          return dateConverter.convertToDate(this.newFirstPaymentDateAsString);
        }
      },
      set(newVal) {
        if (newVal !== null) {
          this.newFirstPaymentDateAsString = dateConverter.convertToString(
            newVal
          );
        } else {
          this.newFirstPaymentDateAsString = null;
        }
      }
    },
    isLastPeriodDateCom: {
      get() {
        return this.isLastPeriodDate;
      },
      set(newVal) {
        this.isLastPeriodDate = newVal;

        if(this.isLastPeriodDate) {
          const firstPaymentDate = dateConverter.convertToDate(this.newFirstPaymentDateAsString);
          const lastDayOfMonth = new Date(firstPaymentDate.getFullYear(), firstPaymentDate.getMonth()+1, 0);

          this.newFirstPaymentDate = lastDayOfMonth;
        }
      }
    }
  },
  created() {
    this.newFirstPaymentDateAsString = this.paymentParams.firstPaymentDate;
    this.isLastPeriodDate = this.paymentParams.isLastPeriodDate;
  },
  methods: {
    cancel() {
      this.newFirstPaymentDateAsString = this.paymentParams.firstPaymentDate;
      this.isLastPeriodDate = this.paymentParams.isLastPeriodDate;
    },

    save() {
      const command = new ChangeFirstPaymentDate(
        this.paymentParams.idInDB,
        this.newFirstPaymentDateAsString,
        this.isLastPeriodDate
      );
      this.$store.commit("eventRegistryPlugin/addOrUpdateCommand", command);
      return true;
    }
  }
};
</script>

<style>
</style>
